<ng-container *ngIf="(store$ | async) as store">
  <mat-toolbar class="bg-white toolbar-size">
    <span>Third Party Providers Contract <span *ngIf="isEdit">Edit</span></span>
    <span class="toolbar-space"></span>
    <button mat-stroked-button color="warn" [swal]="cancelSwal">
      Cancel
    </button>
  </mat-toolbar>
  <ng-third-party-contract
    [customerCompany]="store.companies.customerCompany"
    [providerCompany]="store.companies.providerCompany"
    [authStatus]="store.authorizations.authorizationStatus"
    [lineOfBusiness]="lineOfBusiness"
    [stepIndex]="index"
    [isEdit]="store.stepper.isEdit"
    [isDoneEnabled]="isDoneEnabled">
  </ng-third-party-contract>
</ng-container>
<swal
  #cancelSwal
  title="Are you sure you want to cancel?"
  icon="warning"
  confirmButtonText="Yes"
  cancelButtonText="No"
  [showCancelButton]="true"
  [reverseButtons]="true"
  [heightAuto]="false"
  (confirm)="cancel()">
</swal>
